import { render, staticRenderFns } from "./ContratosBase.vue?vue&type=template&id=70e09d70&"
import script from "./ContratosBase.vue?vue&type=script&lang=ts&"
export * from "./ContratosBase.vue?vue&type=script&lang=ts&"
import style0 from "./ContratosBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('70e09d70', component.options)
    } else {
      api.reload('70e09d70', component.options)
    }
    module.hot.accept("./ContratosBase.vue?vue&type=template&id=70e09d70&", function () {
      api.rerender('70e09d70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/SucursalVirtual/Contratos/ContratosBase.vue"
export default component.exports